// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';
import { getViews } from '@rendering/lookup';
import { VistaprintAuth } from '@vp/auth-react';

export const getPreviewInstructionsUri = documentUri => {
  const UDS_BASE_URL = 'https://uds.documents.cimpress.io/v3';
  const queryParams = {
    documentUri,
  };
  return `${UDS_BASE_URL}/instructions:preview?${qs.stringify(queryParams)}`;
};

const getSceneUrl = sceneData => {
  const SCENES_BASE_URL = 'https://cdn.scenes.documents.cimpress.io/v3';
  const queryParams = {
    data: JSON.stringify(sceneData),
  };
  return `${SCENES_BASE_URL}/transient?${qs.stringify(queryParams)}`;
};

const getPreviewUrl = (previewInstructionsUri, sceneUrl, width) => {
  const RENDERING_BASE_URL = 'https://rendering.documents.cimpress.io/v1';
  const queryParams = {
    width,
    scene: sceneUrl,
    instructions_uri: previewInstructionsUri,
  };
  return `${RENDERING_BASE_URL}/vp/preview?${qs.stringify(queryParams)}`;
};

const PREVIEW_IMAGE_SIZE = 2000;

export const getDocument = async docUrl => {
  try {
    const response = await fetch(docUrl);

    if (!response.ok) {
      throw new Error(`Invalid response from UDS: ${await response.text()}`);
    }

    return await response.json();
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Error calling UDS: ${error.message}`);
    }
  }
};

export const getSurfaces = async docRef => {
  try {
    const doc = docRef.substring(0, docRef.indexOf('/docref'));
    const docJSON = await getDocument(doc);

    const previewInstructionsUri = getPreviewInstructionsUri(doc);

    const document = docJSON?.document;
    const sides = document?.surfaces ?? document?.panels;

    const surfacePreviews = sides.map((surface, index) => {
      const aspectRatio =
        parseInt(surface.height, 10) / parseInt(surface.width, 10);
      const width = PREVIEW_IMAGE_SIZE;
      const height = Math.floor(width * aspectRatio);

      const sceneUrl = getSceneUrl({
        height,
        width,
        page: index + 1,
      });

      return {
        id: `${index}`,
        previewUrl: getPreviewUrl(previewInstructionsUri, sceneUrl, width),
      };
    });

    return surfacePreviews;
  } catch (error) {
    console.log('Error retrieving preview url');
    return [];
  }
};

const buildSceneInfoCombination = displayProductAttributes => {
  // map key and value
  const combination = {};
  displayProductAttributes.forEach(attribute => {
    combination[attribute.key] = attribute.value;
  });
  return combination;
};

export const fetchLookupData = async (
  productKey,
  productVersion,
  displayProductAttributes
) => {
  // lookup doc: https://developer.rendering.cimpress.io/docs/product-preview/lookup

  const combination = buildSceneInfoCombination(displayProductAttributes);
  const fetchLookupRequest = {
    reference: {
      id: productKey,
      version: productVersion,
      attributes: combination,
    },
    tenant: {
      id: 'vistaprint-prod',
      type: 'merchants',
    },
    previewType: ['scene'],
  };

  // get token from authorization header without "Bearer "
  const auth = new VistaprintAuth.WebAuth();
  const token = auth.getAuthorizationHeader().substring(7);

  try {
    const response = await getViews({
      accessToken: token,
      request: fetchLookupRequest,
    });
    return response;
  } catch (error) {
    throw new Error('error fetching lookup data');
  }
};
